import React, { useEffect, useRef, useState } from 'react';
import Loader from 'components/CustomComponents/Loader';
import { retrieveData } from 'helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from 'network/NetworkUtils';
import { useDispatch, useSelector } from 'react-redux';
import { GET_MASTER_BILLERS } from 'network/URLConstants';
import { STATUS_SUCCESS_CODE } from 'network/URLConstants';
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown"
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput"
import { useTranslation } from "react-i18next";
import Yellow from '../../../../../../assets/smi-kudzu-images/yellow.png'
import { handleAmountInputLimitTo2decimal } from 'utils';
import CustomDatePicker from 'components/CustomComponents/CustomDateInput';

const BillerDetails = ({data, onClose, billerTypeToModify: billerTypeToModifyProp}) => {
    const accessToken = useSelector((state) => state.accessToken);
    const SelectedBillers = useSelector(state => state.selectedBillerType);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const dispatch = useDispatch()
    const { t } = useTranslation();
    
    const formatDisplayDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

  
    const reduxBillerTypeToModify = useSelector(x => x.BillerType)
    const billerTypeToModify =
        billerTypeToModifyProp ?? data?.BillerType ?? reduxBillerTypeToModify

         const primaryAcc = useSelector(x => x.primaryAccount)

    return (
        <>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
                            animate__animated animate__fadeInRight '>
                <div className='md:w-[100%] sm:w-[100%] w-full '>

                    <div className={`flex flex-col sm:mx-0 mx-4`}>
                        {!kudzuPlusTrue && (
                            <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                        )}
                        <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                            <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('Biller Details'))}</p>
                        </div>

                        <div className='flex justify-center'>
                            <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>

                                <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Name")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                        {data?.BillerName}</p>
                                </div>
                                 <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Account Number")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                        {data?.AccountNumber}</p>
                                </div>
                                {billerTypeToModify === "P" &&
                                    <>
                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 1")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.Line1}</p>
                                        </div>
                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 2")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.Line2}</p>
                                        </div>
                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("City")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.City}</p>
                                        </div>
                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("STATE")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.State}</p>
                                        </div>

                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("ZIP CODE")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.ZipCode}</p>
                                        </div>

                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Country")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.BillerAddress?.Country}</p>
                                        </div>

                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Phone Number")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {data?.PhoneNumber}</p>
                                        </div>
                                        <div className='mt-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("FROM")}</p>
                                            <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                {primaryAcc?.AccountName}</p>
                                        </div>

                                    </>
                                }
                                     <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Frequency")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                        {data?.FrequencyText}</p>
                                </div>
                                 <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Amount")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                        {data?.Amount}</p>
                                </div>
                                 <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Payment Start Date")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                        {formatDisplayDate(data?.NextDate)}</p>
                                </div>
                                <div className='mt-8'>
                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Payment END Date")}</p>
                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                       {formatDisplayDate(data?.EndDate)}</p>
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-row sm:justify-end w-[85%] justify-between mb-16'>
                            {/* <button
                                // onClick={onCancelClick}
                                className='font-hanken-grotesk
                                    text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px]
                                    text-[16px]'>{t("Cancel")}</button> */}
                            <button
                                 onClick={onClose}
                                //  disabled={isNextDisabled}
                                className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 ${false ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                {t("Close")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default BillerDetails;